/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/wheelchair_medium'
export default icon
